<panel *ngIf="!selected.invoice && (!loading || !partners.empty)">

  <div header class="bold uppercase">
    <span [ngClass]="{'pointer text-primary' : selected.partner}" (click)="select(null)">{{'Đơn trả hàng' | lang}} ({{configs.invoiceResolvableDays}} {{'ngày' | lang}})</span>
    <ng-container *ngIf="selected.partner"><span class="hlf-margin-left hlf-margin-right">|</span>{{selected.partner.Name}}</ng-container>
  </div>

  <div right class="flex">
    <text-filter [target]="partners" *ngIf="!selected.partner" [placeholder]="'Tìm khách hàng'"></text-filter>

    <ng-container *ngIf="selected.partner">
      <text-filter [target]="invoices" [placeholder]="'Tìm đơn hàng'"></text-filter>
      <button *ngIf="selected.partner != all.partner" class="hlf-margin-left bg-danger text-white pointer" (click)="create()"><i class="fa fa-plus"></i></button>
    </ng-container>
  </div>

  <table responsive class="data hover" *ngIf="!selected.partner">
    <tr>
      <th priority="8" class="text-top text-right" style="width: 0">{{'STT' | lang}}</th>
      <th priority="1" class="text-top nowrap"><sortable [target]="partners" [extractor]="extractor('Partner')" [selected]="all.EditableCount + all.ConfirmedCount < 1 ">{{'Khách hàng' | lang}}</sortable></th>
      <th priority="4" class="text-right"><sortable [target]="partners" [extractor]="extractor('ConfirmedCount')" [selected]="all.EditableCount < 1 && all.ConfirmedCount > 0" [sort]="'descending'">{{'Đơn xong' | lang}}</sortable></th>
      <th priority="3" class="text-right"><sortable [target]="partners" [extractor]="extractor('EditableCount')" [selected]="all.EditableCount > 0" [sort]="'descending'">{{'Đơn chờ' | lang}}</sortable></th>
      <th priority="5" class="text-right"><sortable [target]="partners" [extractor]="extractor('Count')">{{'Số cây' | lang}}</sortable></th>
      <th priority="7" class="text-right"><sortable [target]="partners" [extractor]="extractor('LengthActualQuantity')">{{'Số mét' | lang}}</sortable></th>
      <th priority="7" class="text-right"><sortable [target]="partners" [extractor]="extractor('WeightActualQuantity')">{{'Số cân' | lang}}</sortable></th>
      <th priority="6" class="text-right"><sortable [target]="partners" [extractor]="extractor('Total')">{{'Tổng tiền' | lang}}</sortable></th>
      <th priority="2" class="text-right" style="width: 0"></th>
    </tr>
    <tr *ngFor="let i of partners.pageMatches; index as ix" class="pointer">
      <td (click)="select(i)"><small>{{ix + 1 + partners.pageIndex * partners.pageSize}}</small></td>
      <td (click)="select(i)">
        <div class="text-primary bold uppercase">{{i.partner.Name}}</div>
        <small class="uppercase spacy">K{{i.partner.ID}}</small>
      </td>
      <td (click)="select(i)">
        <span class="text-danger">{{i.ConfirmedCount | number : '1.0-0' : 'en-US'}}</span><unit>{{'đơn' | lang}}</unit>
        <div class="small" *ngIf="i.ConfirmedCount > 0">{{i.ConfirmedStamp | date : 'dd-MM-yyyy'}}</div>
      </td>
      <td (click)="select(i)">
        <span class="text-warning">{{i.EditableCount | number : '1.0-0' : 'en-US'}}</span><unit>{{'đơn' | lang}}</unit>
        <div class="small" *ngIf="i.EditableCount > 0">{{i.EditableStamp | date : 'dd-MM-yyyy'}}</div>
      </td>
      <td (click)="select(i)">
        {{i.WeightCount + i.LengthCount | number : '1.0-0' : 'en-US'}}<unit>{{'cây' | lang}}</unit>
      </td>
      <td (click)="select(i)">
        {{i.LengthActualQuantity | number : '1.1-1' : 'en-US'}}<m></m>
      </td>
      <td (click)="select(i)">
        {{i.WeightActualQuantity | number : '1.1-1' : 'en-US'}}<kg></kg>
      </td>
      <td (click)="select(i)" class="text-danger">
        <span class="text-danger">{{i.Total | number : '1.0-0' : 'en-US'}}</span><vnd></vnd>
      </td>
      <td (click)="select(i); create()">
        <i class="fa fa-plus text-danger std-margin-left std-margin-right"></i>
      </td>
    </tr>

    <tr *ngIf="partners.pages.length > 1">
      <td style="display: none"></td>
      <td [colSpan]="9" style="display: table-cell !important; z-index: unset" class="text-center"><pagination [target]="partners"></pagination></td>
    </tr>

    <tr class="footer bold text-primary pointer" *ngIf="partners.source.length == partners.matches.length" (click)="select(all)">
      <td><i class="fa fa-info-circle"></i></td>
      <td class="uppercase">{{all.partner.Name}}</td>
      <td>{{all.ConfirmedCount | number : '1.0-0' : 'en-US'}}<unit>{{'đơn' | lang}}</unit></td>
      <td>{{all.EditableCount | number : '1.0-0' : 'en-US'}}<unit>{{'đơn' | lang}}</unit></td>
      <td>{{all.WeightCount + all.LengthCount | number : '1.0-0' : 'en-US'}}<unit>{{'cây' | lang}}</unit></td>
      <td>{{all.LengthActualQuantity | number : '1.1-1' : 'en-US'}}<m></m></td>
      <td>{{all.WeightActualQuantity | number : '1.1-1' : 'en-US'}}<kg></kg></td>
      <td>{{all.Total | number : '1.0-0' : 'en-US'}}<vnd></vnd></td>
      <td></td>
    </tr>
  </table>

  <table responsive class="data hover" *ngIf="selected.partner">
    <tr>
      <th priority="9" class="text-top text-right">STT</th>
      <th priority="6" class="text-top text-left nowrap"><sortable [target]="invoices" [extractor]="extractor('Stamp')">{{'Ngày' | lang}}</sortable></th>
      <th priority="1" class="text-top text-center"><sortable [target]="invoices" [extractor]="extractor('ID')" [selected]="true">{{'Mã đơn' | lang}}</sortable></th>
      <th priority="3" class="text-top text-center"><sortable [target]="invoices" [extractor]="extractor('State')">{{'Trạng thái' | lang}}</sortable></th>
      <th priority="8" class="text-top text-center"><sortable [target]="invoices" [extractor]="extractor('SKUCount')">{{'Mặt hàng' | lang}}</sortable></th>
      <th priority="5" class="text-top text-center"><sortable [target]="invoices" [extractor]="extractor('Count')">{{'Số cây' | lang}}</sortable></th>
      <th priority="7" class="text-top text-right"><sortable [target]="invoices" [extractor]="extractor('LengthQuoteQuantity')">{{'Số mét' | lang}}</sortable></th>
      <th priority="7" class="text-top text-right"><sortable [target]="invoices" [extractor]="extractor('WeightQuoteQuantity')">{{'Số cây' | lang}}</sortable></th>
      <th priority="2" class="text-top text-right"><sortable [target]="invoices" [extractor]="extractor('Total')">{{'Tổng tiền' | lang}}</sortable></th>
    </tr>
    <tr *ngFor="let i of invoices.pageMatches; index as ix" class="pointer" (click)="open(i)">
      <td><small>{{ix + 1 + invoices.pageSize * invoices.pageIndex}}</small></td>
      <td>{{i.Stamp | date : 'dd-MM-yyyy'}}</td>
      <td>
        <div class="spacy bold text-danger">{{i.Tag}}</div>
        <div class="small uppercase" *ngIf="selected.partner.ID < 1">{{partner(i).Name}}</div>
      </td>
      <td class="uppercase small nowrap" [ngClass]="{'text-warning': i.State == 1, 'text-success': i.State == 2}">{{state(i) | lang}}</td>
      <td>{{i.SKUCount | number : '1.0-2' : 'en-US'}}</td>
      <td>{{i.LengthCount + i.WeightCount | number : '1.0-0' : 'en-US'}}</td>
      <td>{{i.LengthQuoteQuantity | number : '1.1-1' : 'en-US'}}<m></m></td>
      <td>{{i.WeightQuoteQuantity | number : '1.1-1' : 'en-US'}}<kg></kg></td>
      <td class="text-danger">{{i.Total | number : '1.1-1' : 'en-US'}}<unit>{{i.Icon}}</unit></td>
    </tr>
    <tr class="footer" *ngIf="invoices.pages.length > 1">
      <td [colSpan]="9" class="text-center" style="display: table-cell !important"><pagination [target]="invoices"></pagination></td>
    </tr>
  </table>

</panel>

<div class="container" *ngIf="selected.invoice">

  <div class="scrollable-x" #scrollableX>
    <div class="flex row">

      <panel class="editor" [header]="false">

        <div class="flex col">

          <div class="flex space-between items-center header">
            <div class="bold uppercase">{{selected.invoice.ID < 1 ? ('Tạo đơn nhập hàng trả lại mới' | lang) : ('Chỉnh sửa đơn nhập hàng trả lại' | lang) + ' ' + selected.invoice.Tag}} {{'từ' | lang}} {{selected.partner.Name}} (<span [ngClass]="{'text-primary pointer' : editable}" (click)="editStamp()">{{selected.invoice.Stamp | date : 'dd-MM-yyyy'}}</span>)</div>
            <small *ngIf="selected.invoice.ID > 0" class="button uppercase" (click)="close()">{{'Đóng đơn' | lang}}</small>
          </div>

          <div class="flex row">

            <div class="scrollable" #scrollableLeft>

              <table responsive class="data" *ngIf="selected.invoice">
                <tr>
                  <th class="text-top text-left">{{'Mã hàng' | lang}}</th>
                  <th class="text-top text-center">{{'Màu' | lang}}</th>
                  <th class="text-top text-center">{{'Số cây' | lang}}</th>
                  <th class="text-top text-left">{{'Độ dài từng cây' | lang}}</th>
                  <th class="text-top text-right">{{'Tổng dài' | lang}}</th>
                  <th class="text-top text-center">{{'Khấu trừ (m)' | lang}}</th>
                  <th class="text-top text-right">{{'Tính tiền' | lang}}</th>
                  <th class="text-top text-right">{{'Giá nhập' | lang}}</th>
                  <th class="text-top text-right">{{'Thành tiền' | lang}}</th>
                  <th class="text-top text-right" *ngIf="editable"></th>
                </tr>

                <tr *ngFor="let i of selected.details">
                  <td>
                    <good class="bold spacy nowrap" [sku]="i.SKU"></good>
                    <br />
                    <small class="spacy uppercase" [ngClass]="{'text-danger': !i.Identified}">{{i.Identified ? i.ImportInvoiceTag : ('không rõ' | lang)}}</small>
                  </td>
                  <td class="bold">{{i.Color}}</td>
                  <td class=" text-info bold">{{i.records.length | number : '1.0-0' : 'en-US'}}</td>
                  <td>
                    <div class="flex inputs">
                      <span *ngFor="let o of i.records">
                        <span *ngIf="i.Identified">{{o.ActualQuantity | number : '1.0-1' : 'en-US'}}</span>
                        <number-input *ngIf="!i.Identified" [value]="o.ActualQuantity" [fit]="true" [allowNegative]="false" [decimalPlaces]="1" class="text-center text-danger" (change)="editLength(o, $event.target)"></number-input>
                        <i class="fa fa-times pointer text-danger" (click)="remove([o])"></i>
                      </span>
                    </div>
                  </td>
                  <td>
                    <b>{{statistics('ActualQuantity', [i]) | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="i.Unit"></product-unit>
                  </td>
                  <td>
                    <span *ngIf="i.Identified">{{statistics('ReducedQuantity', [i]) | number : '1.1-1' : 'en-US'}}</span>
                    <number-input *ngIf="!i.Identified" [value]="statistics('ReducedQuantity', [i])" [decimalPlaces]="1" [allowNegative]="false" class="text-danger text-right" [fit]="true" (change)="editDiscount(i, $event.target)"></number-input>
                    <product-unit [type]="i.Unit"></product-unit>
                  </td>
                  <td>
                    <b>{{statistics('QuoteQuantity', [i]) | number : '1.1-1' : 'en-US'}}</b><unit>m</unit>
                  </td>
                  <td class="nowrap">
                    <b *ngIf="i.Identified">{{i.ExportUnitPrice | number : '1.0-1' : 'en-US'}}</b>
                    <number-input *ngIf="!i.Identified" class="bold text-danger text-right" [value]="i.ExportUnitPrice" [allowNegative]="0" [decimalPlaces]="0" [fit]="true" (change)="editPrice(i, $event.target)"></number-input>
                    <symbol-per-unit [symbol]="selected.invoice.Icon" [type]="i.Unit"></symbol-per-unit>
                  </td>
                  <td>
                    <b>{{statistics('Total', [i]) | number : '1.0-1' : 'en-US'}}</b><unit>{{selected.invoice.Icon}}</unit>
                  </td>
                  <td *ngIf="editable"><i class="fa fa-times pointer text-danger" (click)="remove(i.records)"></i></td>
                </tr>

                <tr *ngIf="sum('Count', 1) > 0 && sum('Count', 2) > 0">
                  <td class="bold uppercase">
                    <div>{{'Tổng mét' | lang}}</div>
                    <div>{{'Tổng cân' | lang}}</div>
                  </td>
                  <td></td>
                  <td>
                    <div><b>{{sum('Count', 1) | number : '1.0-0' : 'en-US'}}</b></div>
                    <div><b>{{sum('Count', 2) | number : '1.0-0' : 'en-US'}}</b></div>
                  </td>
                  <td></td>
                  <td>
                    <div><b>{{sum('ActualQuantity', 1) | number : '1.1-1' : 'en-US'}}</b><m></m></div>
                    <div><b>{{sum('ActualQuantity', 2) | number : '1.1-1' : 'en-US'}}</b><kg></kg></div>
                  </td>
                  <td>
                    <div><b>{{sum('ReducedQuantity', 1) | number : '1.1-1' : 'en-US'}}</b><m></m></div>
                    <div><b>{{sum('ReducedQuantity', 2) | number : '1.1-1' : 'en-US'}}</b><kg></kg></div>
                  </td>
                  <td>
                    <div><b>{{sum('QuoteQuantity', 1) | number : '1.1-1' : 'en-US'}}</b><m></m></div>
                    <div><b>{{sum('QuoteQuantity', 2) | number : '1.1-1' : 'en-US'}}</b><kg></kg></div>
                  </td>
                  <td></td>
                  <td>
                    <div><b>{{sum('Total', 1) | number : '1.0-0' : 'en-US'}}</b><vnd></vnd></div>
                    <div><b>{{sum('Total', 2) | number : '1.0-0' : 'en-US'}}</b><vnd></vnd></div>
                  </td>
                </tr>

                <tr class="footer text-primary" *ngIf="selected.details.length > 0">
                  <td class="bold uppercase nowrap">{{'Tổng đơn' | lang}}</td>
                  <td></td>
                  <td><b>{{sum('Count') | number : '1.0-0' : 'en-US'}}</b></td>
                  <td></td>
                  <td>
                    <b>{{sum('ActualQuantity') | number : '1.1-1' : 'en-US'}}</b>
                    <m *ngIf="sum('Count', 1) > 0 && sum('Count', 2) < 1"></m>
                    <kg *ngIf="sum('Count', 2) > 0 && sum('Count', 1) < 1"></kg>
                    <unit *ngIf="sum('Count', 2) > 0 && sum('Count', 1) > 0">{{'đv' | lang}}</unit>
                  </td>
                  <td>
                    <b>{{sum('ReducedQuantity') | number : '1.1-1' : 'en-US'}}</b>
                    <m *ngIf="sum('Count', 1) > 0 && sum('Count', 2) < 1"></m>
                    <kg *ngIf="sum('Count', 2) > 0 && sum('Count', 1) < 1"></kg>
                    <unit *ngIf="sum('Count', 2) > 0 && sum('Count', 1) > 0">{{'đv' | lang}}</unit>
                  </td>
                  <td>
                    <b>{{sum('QuoteQuantity') | number : '1.1-1' : 'en-US'}}</b>
                    <m *ngIf="sum('Count', 1) > 0 && sum('Count', 2) < 1"></m>
                    <kg *ngIf="sum('Count', 2) > 0 && sum('Count', 1) < 1"></kg>
                    <unit *ngIf="sum('Count', 2) > 0 && sum('Count', 1) > 0">{{'đv' | lang}}</unit>
                  </td>
                  <td></td>
                  <td><b>{{sum('Total') | number : '1.0-0' : 'en-US'}}</b><vnd></vnd></td>
                  <td></td>
                </tr>
              </table>

            </div>
            <scrollbar [target]="scrollableLeft"></scrollbar>

          </div>

          <div class="flex">
            <button *ngIf="!selected.invoice && selected.partner && !returnable.empty" class="bg-primary text-white" (click)="create()"><span>{{'Tạo đơn nhập hàng trả lại mới từ' | lang}} {{selected.partner.Name}}</span></button>
            <button *ngIf="savable" class="bg-primary text-white" (click)="save()"><span>{{(selected.invoice.ID > 0 ? 'Cập nhập đơn nhập hàng trả lại' : 'Tạo đơn nhập hàng trả lại') | lang}}</span></button>
            <button *ngIf="confirmable" class="bg-danger text-white" (click)="confirm()"><span>{{'Xác nhận đơn nhập hàng trả lại' | lang}}</span></button>
            <button *ngIf="cancelable" class="bg-success text-white" (click)="cancel()"><span>{{'Hủy đơn nhập hàng trả lại' | lang}}</span></button>
          </div>
        </div>
      </panel>

      <panel class="editor" [header]="false">

        <div class="flex col">

          <div class="header">
            <text-filter [target]="returnable" [placeholder]="'Tìm hàng'"></text-filter>
            <button class="bg-warning text-white pointer hlf-margin-left" (click)="importXlsx()"><i class="fa fa-file-excel"></i></button>
          </div>          

          <div class="flex row">
            <div class="scrollable" #scrollableRight>

              <table class="data hover" *ngIf="selected.invoice">                
                <tr>
                  <th class="text-left">{{'Mã hàng' | lang}}</th>
                  <th class="text-center">{{'Màu' | lang}}</th>
                  <th class="text-center">{{'SL' | lang}}</th>
                  <th class="text-center">{{'m / kg' | lang}}</th>
                  <th class="text-right">{{'Giá' | lang}}</th>
                  <th class="text-right">{{'Nguồn' | lang}}</th>
                </tr>
                <tr *ngFor="let i of returnable.pageMatches" (click)="add(i)">
                  <td class="text-top text-left"><good class="bold spacy nowrap" [sku]="i.SKU"></good></td>
                  <td class="text-top text-center bold text-info">{{i.Color}}</td>
                  <td class="text-top text-center nowrap" [ngClass]="{'uppercase small': i.records.length < 1}">{{i.records.length > 0 ? (i.records.length | number : '1.0-0' : 'en-US') : ('không rõ' | lang)}}</td>
                  <td class="text-top text-center nowrap">
                    <div *ngIf="i.records.length > 0">{{i.ActualQuantity | number : '1.0-1' : 'en-US'}}<product-unit [type]="i.Unit"></product-unit></div>
                    <div *ngIf="i.records.length < 1" class="small uppercase nowrap">{{'không rõ' | lang}}</div>
                    <small *ngIf="i.ActualQuantity - i.QuoteQuantity > 0"><unit class="hlf-margin-right">trừ</unit>{{i.ActualQuantity - i.QuoteQuantity | number : '1.0-1' : 'en-US'}}<product-unit [type]="i.Unit"></product-unit></small>
                  </td>
                  <td class="text-top text-right">
                    <span *ngIf="i.records.length > 0">{{i.ExportUnitPrice | number : '1.0-2' : 'en-US'}}<symbol-per-unit [type]="i.Unit" [symbol]="selected.invoice.Icon"></symbol-per-unit></span>
                    <small *ngIf="i.records.length < 1" class="uppercase nowrap">{{'không rõ' | lang}}</small>
                  </td>
                  <td class="text-top text-right">
                    <small *ngIf="i.records.length > 0" class="spacy">{{i.ImportInvoiceTag}}</small>
                    <small *ngIf="i.records.length < 1" class="uppercase nowrap">{{'không rõ' | lang}}</small>
                    <br />
                    <small *ngIf="i.records.length > 0">{{source(i.ImportInvoiceTag)}}</small>
                  </td>
                </tr>
                <tr class="footer" *ngIf="returnable.pages.length > 1">
                  <td [colSpan]="6" class="text-center"><pagination [target]="returnable"></pagination></td>
                </tr>
              </table>

            </div>
            <scrollbar [target]="scrollableRight"></scrollbar>
          </div>
        </div>
      </panel>

    </div>
  </div>

  <scrollbar *ngIf="selected.invoice" [target]="scrollableX" class="bottom"></scrollbar>

</div>

<ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true}"></ngx-loading>
